import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/RegistrationApi/" );

/* eslint-disable arrow-body-style */

/**
 * List web account user type parents
 */
export const webAccountUserTypeParents = () => {
  return instance.get( "ListWebAccountUserTypeParents" );
};

/**
 * List job types
 *
 * @param {number} userTypeParentId The user type parent ID whose job types we want to load
 */
export const jobTypes = ( userTypeParentId ) => {
  return instance.get( `ListJobTypes?userTypeParentId=${userTypeParentId}` );
};

/**
 * Register a web account
 *
 * @param {object} account The web account details to register
 * @param {object} orgMetaData Organisation meta data to save
 * @param {boolean} marketingOptIn Whether the user opted into marketing communications
 */
export const register = ( account, orgMetaData, marketingOptIn ) => {
  return instance.post( "Register", { account, orgMetaData, marketingOptIn } );
};
